import { URLSearchParamsInit, createSearchParams } from 'react-router-dom';

export function createURLSearchParamString(
  searchParamsObj: URLSearchParamsInit,
) {
  return `?${createSearchParams(searchParamsObj)}`;
}
